import { trendingHot, latestFeed } from "@/mocks/heiliaoHome";

export default function HotPanel() {
  const featured = latestFeed[0];
  return (
    <section className="w-full">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-5 md:mb-7">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="h-4 w-1 rounded-full bg-primary-500"></span>
              <span className="text-xs font-semibold tracking-[0.2em] text-primary-700 uppercase">今日热议 · 热到烫手</span>
            </div>
            <h2 className="font-serif text-2xl md:text-4xl font-black text-foreground-950 leading-tight">
              正在被刷屏的瓜
            </h2>
          </div>
          <a
            href="#feed"
            className="whitespace-nowrap inline-flex items-center gap-2 rounded-md bg-background-50 border border-background-300/70 px-4 py-2 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer"
          >
            去围观更多 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 md:gap-6 items-stretch">
          {/* 左：热议榜单 */}
          <div className="lg:col-span-3 rounded-lg border border-background-200/70 bg-background-100/60 p-3 md:p-4">
            <div className="flex items-center justify-between px-2 py-2">
              <div className="flex items-center gap-2">
                <span className="grid place-items-center h-7 w-7 rounded-md bg-primary-500 text-background-50"><i className="ri-fire-fill"></i></span>
                <span className="text-sm font-bold text-foreground-950">热度榜 TOP 6</span>
              </div>
              <span className="text-[11px] text-foreground-500">每 5 分钟更新</span>
            </div>
            <div className="mt-1 divide-y divide-background-200/70">
              {trendingHot.map((item) => (
                <a
                  key={item.rank}
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="group flex items-center gap-3 px-2 py-3.5 rounded-md hover:bg-background-50 transition-colors cursor-pointer"
                >
                  <span
                    className={`w-8 font-serif text-xl md:text-2xl font-black ${
                      Number(item.rank) <= 3 ? "text-primary-500" : "text-background-400"
                    }`}
                  >
                    {item.rank}
                  </span>
                  <span className="flex flex-1 flex-col min-w-0">
                    <span className="truncate text-sm md:text-[15px] font-medium text-foreground-900 group-hover:text-primary-700 transition-colors">
                      {item.title}
                    </span>
                    <span className="mt-0.5 flex items-center gap-2 text-[11px] text-foreground-500">
                      <span className="inline-flex items-center gap-0.5">
                        <i className={`${item.trend === "up" ? "ri-arrow-up-line" : "ri-arrow-down-line"} ${item.trend === "up" ? "text-primary-500" : "text-foreground-400"}`}></i>
                        {item.heat} 热度
                      </span>
                      <span className="rounded bg-background-200/60 px-1.5 py-0.5">{item.tag}</span>
                    </span>
                  </span>
                  <i className="ri-arrow-right-s-line text-lg text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
                </a>
              ))}
            </div>
          </div>

          {/* 右：大卡头条 */}
          <a
            href="#"
            onClick={(e) => e.preventDefault()}
            className="lg:col-span-2 group flex flex-col rounded-lg overflow-hidden border border-background-200/70 bg-background-50 hover:border-primary-200 transition-colors cursor-pointer"
          >
            <div className="relative overflow-hidden">
              <img
                src={featured.img}
                alt={featured.title}
                title={`${featured.title} · 1黑料网`}
                className="w-full aspect-[4/3] object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 inline-flex items-center gap-1 rounded-full bg-primary-500 text-background-50 px-3 py-1 text-[11px] font-bold">
                <i className="ri-fire-fill text-sm"></i> 今日头条
              </span>
            </div>
            <div className="flex flex-1 flex-col p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className={`rounded-md px-2 py-0.5 text-[11px] font-medium ${featured.tagClass}`}>{featured.tag}</span>
                <span className="text-[11px] text-foreground-400">{featured.area}</span>
              </div>
              <h3 className="font-serif text-lg md:text-xl font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                {featured.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-2">{featured.excerpt}</p>
              <div className="mt-4 flex items-center justify-between text-[11px] text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <span className="grid place-items-center h-6 w-6 rounded-full bg-secondary-200 text-secondary-900 text-[10px] font-bold">周</span>
                  {featured.author}
                </span>
                <span className="flex items-center gap-3">
                  <span className="flex items-center gap-1"><i className="ri-chat-3-line"></i>{featured.comments}</span>
                  <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{featured.views}</span>
                </span>
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}